import { Link } from "react-router-dom";

// Shared, brand-agnostic chrome for the 3 test-harness pages. Neutral
// slate/white palette with a single indigo accent. Kept deliberately
// simple — the point of these pages is to give Pinlayr a clean generic
// surface to overlay on, not to be a real site.

export const SiteHeader = () => (
  <header
    data-testid="site-header"
    className="sticky top-0 z-30 w-full border-b border-slate-200 bg-white/90 backdrop-blur"
  >
    <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5 sm:px-8">
      <Link to="/demo/landing" data-testid="site-logo" className="flex items-center gap-2">
        <span className="grid h-7 w-7 place-items-center rounded-md bg-indigo-600 text-white text-sm font-bold">P</span>
        <span className="text-[15px] font-semibold tracking-tight text-slate-900">Pinlayr Demo</span>
      </Link>
      <nav data-testid="site-nav" className="flex items-center gap-6 text-sm font-medium text-slate-600">
        <Link to="/demo/landing" className="hover:text-slate-900 transition-colors">Home</Link>
        <Link to="/demo/article" className="hover:text-slate-900 transition-colors">Article</Link>
        <Link to="/demo/product" className="hover:text-slate-900 transition-colors">Product</Link>
      </nav>
    </div>
  </header>
);

export const SiteFooter = () => (
  <footer
    data-testid="site-footer"
    className="mt-24 border-t border-slate-200 bg-slate-50"
  >
    <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-5 py-10 text-sm text-slate-500 sm:flex-row sm:px-8">
      <div className="flex items-center gap-2">
        <span className="grid h-6 w-6 place-items-center rounded bg-slate-900 text-white text-xs font-bold">P</span>
        <span>Pinlayr — Commenting Suite</span>
      </div>
      <p>Sample test harness · {new Date().getFullYear()}</p>
    </div>
  </footer>
);
